import {fork, select, take} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as userProfileActionTypes from '../userProfileActionTypes';

const initiateExportUserAccountList = function* initiateExportUserAccountList({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const eupFileAssetsService = serviceManager.loadService('eupFileAssetsService');

    const {url, fileName} = payload;

    yield fork(
        fetchRequest,
        userProfileActionTypes.EXPORT_USER_ACCOUNT_LIST_REQUEST,
        eupFileAssetsService.downloadFile,
        {
            fileName,
            url,
        },
    );

    yield take([
        userProfileActionTypes.EXPORT_USER_ACCOUNT_LIST_REQUEST_SUCCEEDED,
        userProfileActionTypes.EXPORT_USER_ACCOUNT_LIST_REQUEST_FAILED,
    ]);
};

export default initiateExportUserAccountList;
